import { BaseDTO } from '../basedto';
export class PackageEngineerDTO extends BaseDTO {
    EngineerUserId: number;
}